<div class="user-item" (click)="selectRoom(room)">

    <div class="check-circle">
        <mat-icon svgIcon="check-circle" *ngIf="isSelected; else uncheck"></mat-icon>
        <ng-template #uncheck>
            <div class="icon uncheck-circle"></div>
        </ng-template>
    </div>
    <div class="name no-copy" [matTooltip]="roomName" [matTooltipPosition]="'above'" [matTooltipDisabled]="!isToolTip"
        #roomNameEl>{{roomName}}</div>
    <div class="auto"></div>
    <div class="user-title">{{roomType}}</div>
</div>